app.directive('medipassWidget', ['$window', '$timeout', '$q', 'TyroAPI', 'ENV', function ($window, $timeout, $q, TyroAPI, ENV) {
    return {
        restrict: 'E',
        scope: {
            token: '=',
            renderOptions: '=',
            accountPaymentId: '<',
            accountItemsId: '<',
            transactionType: '<',
            claimableItemIds: '<',
            onComplete: '&',
        },
        link: function (scope, element, attrs) {
            scope.$watchGroup(['token', 'renderOptions', 'transactionType'], function (newValues) {
                var token = newValues[0];
                var renderOptions = newValues[1];
                var transactionType = newValues[2];

                if (!token || !renderOptions) {
                    return;
                }

                const requestData = {
                    'patient_id': parseInt(renderOptions.patient.refId, 10),
                    'account_payment_id': scope.accountPaymentId,
                    'account_items_id': scope.accountItemsId,
                    'transaction_type': transactionType,
                    'claimable_item_ids': (scope.claimableItemIds || []).slice(),
                };

                TyroAPI.createTransaction(requestData).then(function (response) {
                    const transaction = response.data;

                    // The SDK was left without a claim reaching the funder, so the transaction row is
                    // discarded and its claimable items go back to the pending queue server side.
                    const ABANDONED_STATUSES = ['cancelled', 'canceled', 'error'];

                    // Resolves once the row is gone, so the host refetches its pending items after the
                    // release rather than racing it.
                    function discardIfNothingClaimed(status) {
                        if (ABANDONED_STATUSES.indexOf(String(status).toLowerCase()) === -1) {
                            return $q.resolve();
                        }
                        return TyroAPI.deleteTransaction(transaction.transaction_id, renderOptions.patient.refId)
                            .catch(function (error) {
                                // Items stay claimed if this fails - not worth blocking the return. Status only:
                                // the rejection carries the request config, Authorization header included.
                                console.error('Failed to discard the abandoned transaction:', error && error.status);
                            });
                    }

                    $timeout(function () {
                        $window.MedipassTransactionSDK.setConfig({
                            // Production only on a production domain; dev and localhost stay on staging.
                            env: ENV.MEDIPASS_ENV,
                            appVersion: "0.0.0",
                            token: token,
                            appId: "cattrax-web"
                        });

                        const url = $window.location.origin + '/' + ENV.API + '/api/tyro/webhooks/patient/' + transaction.patient_id + '/transaction/' + transaction.transaction_id;

                        $window.MedipassTransactionSDK.renderCreateTransaction(
                            renderOptions,
                            {
                                allowEdit: false,
                                disableModifyServiceItems: false,
                                version: "3",
                                webhooks: [
                                    {
                                        url: url,
                                        event: 'invoiceCancelled',
                                        method: 'POST',
                                        headers: { "X-Session-Key": transaction.session_key }
                                    },
                                    {
                                        url: url,
                                        event: 'invoiceBalancePaid',
                                        method: 'POST',
                                        headers: { "X-Session-Key": transaction.session_key }
                                    },
                                    {
                                        url: url,
                                        event: 'healthFundApprovedInvoice',
                                        method: 'POST',
                                        headers: { "X-Session-Key": transaction.session_key }
                                    },
                                    {
                                        url: url,
                                        event: 'healthFundRejectedInvoice',
                                        method: 'POST',
                                        headers: { "X-Session-Key": transaction.session_key }
                                    },
                                    {
                                        url: url,
                                        event: 'healthFundPaidInvoice',
                                        method: 'POST',
                                        headers: { "X-Session-Key": transaction.session_key }
                                    }
                                ],
                                // Deliberately not logged: the SDK's transaction and error objects carry the
                                // patient's name, Medicare / DVA number and items. onCloseModal owns the outcome.
                                onSuccess: function () {},
                                onError: function () {},
                                onCancel: function () {},
                                // The one callback that fires however the SDK is left, so it owns the cleanup;
                                // onCancel does not always run.
                                onCloseModal: function ({ transaction: sdkTransaction, error, status }) {
                                    discardIfNothingClaimed(status).finally(function () {
                                        $timeout(function () {
                                            if (scope.onComplete) {
                                                scope.onComplete({
                                                    status: status,
                                                    payload: error || sdkTransaction
                                                });
                                            }
                                        });
                                    });
                                },
                                onTransactionCreated: function () {},
                                onTransactionUpdated: function () {}
                            });
                    }, 0);
                }).catch(function () {
                    // Without a transaction row there is nothing for the SDK to render, so the host is told
                    // rather than left looking at an empty panel.
                    if (scope.onComplete) {
                        scope.onComplete({ status: 'CREATE_FAILED', payload: null });
                    }
                });
            });
        }
    };
}]);